// src/utils/http/normalizeHttpError.ts
import { AxiosError } from "axios";

/**
 * Extrai mensagens de erro de respostas do NestJS/class-validator ou de rede.
 * Retorna sempre um array de mensagens legíveis para exibir em toasts.
 */
export function normalizeHttpError(err: unknown): string[] {
  const msgs: string[] = [];

  const ax = err as AxiosError<any>;
  const data = ax?.response?.data;

  // Padrão NestJS: { statusCode, error, message }
  if (
    data &&
    (Object.prototype.hasOwnProperty.call(data, "message") || data.error)
  ) {
    const msgField = (data as any).message;

    if (Array.isArray(msgField)) {
      // class-validator geralmente já manda string[]
      for (const m of msgField) {
        if (typeof m === "string" && m.trim()) msgs.push(m.trim());
        // fallback para caso raro de objetos com constraints
        else if (m && typeof m === "object" && m.constraints) {
          for (const k of Object.keys(m.constraints)) {
            const v = m.constraints[k];
            if (typeof v === "string" && v.trim()) msgs.push(v.trim());
          }
        }
      }
    } else if (typeof msgField === "string" && msgField.trim()) {
      msgs.push(msgField.trim());
    } else if (
      msgField &&
      typeof msgField === "object" &&
      msgField.constraints
    ) {
      for (const k of Object.keys(msgField.constraints)) {
        const v = msgField.constraints[k];
        if (typeof v === "string" && v.trim()) msgs.push(v.trim());
      }
    }

    if (msgs.length === 0 && typeof (data as any).error === "string") {
      msgs.push((data as any).error);
    }
  }

  // Erro de rede (sem response)
  if (msgs.length === 0 && ax?.request && !ax?.response) {
    msgs.push(
      "Falha de conexão com o servidor. Verifique sua internet e tente novamente."
    );
  }

  // Outros formatos comuns
  if (msgs.length === 0) {
    const anyErr = err as any;
    if (Array.isArray(anyErr?.message)) {
      for (const m of anyErr.message)
        if (typeof m === "string" && m.trim()) msgs.push(m.trim());
    } else if (typeof anyErr?.message === "string" && anyErr.message.trim()) {
      msgs.push(anyErr.message.trim());
    }
  }

  // Fallback final
  if (msgs.length === 0) {
    msgs.push("Ocorreu um erro ao processar sua solicitação.");
  }

  return msgs;
}
